import React, {Fragment, useEffect, useRef} from 'react';
import {useTranslation} from "react-i18next";
import {Button, Flex, Form, message} from "antd";
import useSWRMutation from "swr/mutation";
import {roaming_document_sync_created_period, supplier_all} from "../api/api";
import {afterRequest, getRequest, postRequest} from "../api/config";
import dayjs from "dayjs";
import MyModal from "./Modal";
import FormItems from "./FormItems";
import {getOptionsArray} from "./component";

const SyncByCreatedPeriod = () => {

    const ref = useRef();
    const debounceTimeoutRef = useRef(null);

    const {t} = useTranslation();
    const [form] = Form.useForm();


    const executor_inn = Form.useWatch('supplier_inn', form)
    const {trigger, isMutating} = useSWRMutation(roaming_document_sync_created_period, postRequest);
    const {trigger: supplierInnTrigger, data: dataExecutorInn = []} = useSWRMutation({
        url: supplier_all,
        params: {search: executor_inn}
    }, getRequest);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            if (executor_inn) {
                supplierInnTrigger().then()
            }
        }, 1000)

        return () => {
            clearTimeout(debounceTimeoutRef.current);
        };
    }, [executor_inn]);

    const onSubmit = (formData) => {

        const {date, supplier_inn} = formData

        const data = {
            supplier_inn: supplier_inn ? supplier_inn?.split(" ")?.[0] : "",
            start:  dayjs(date[0]).format("YYYY-MM-DD"),
            end:  dayjs(date[1]).format("YYYY-MM-DD")
        }

        afterRequest(trigger, {data}, () => {
            ref?.current?.closeModal();
            message?.open({
                content: t('successfully'),
                key: 'updatable',
                type: 'success'
            });
        })

    }

    const onCancel = () => {
        form.resetFields();
    }

    const fields = [
        {
            name: "date",
            type: "rangePicker",
            allowClear: true,
            format: "DD.MM.YYYY",
            required: true,
        },
        {
            label: t('supplierInn'),
            name: "supplier_inn",
            allowClear: true,
            type: 'autocomplete',
            options: getOptionsArray(dataExecutorInn, ['inn', 'code', 'name'], {
                label: (i) => <>
                    {i.inn} {i.code} {i.name}
                </>
            }),
        },
    ]

    return (
        <Fragment>
            <MyModal afterClose={onCancel} modalTitle={t('Синхронизация по дате создания')} button={false} ref={ref}>
                <Form form={form}  layout={"vertical"} onFinish={onSubmit}>
                    <FormItems
                        formItems={fields}
                    />
                    <Flex justify={'flex-end'}>
                        <Button type="primary" htmlType="submit" loading={isMutating}>
                            {t("Подвердить")}
                        </Button>
                    </Flex>
                </Form>
            </MyModal>

            <Button size={"large"}
                    onClick={() => ref?.current?.openModal()}>{t('Синхронизация по дате создания')}</Button>
        </Fragment>
    );
};

export default SyncByCreatedPeriod;